import { useEffect } from "react";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { apiMain } from "@/common/services";

export const useDetectGeolocation = () => {
  const setCountry = useGeolocationStore((state) => state.setCountry);
  const setBlockedState = useGeolocationStore((state) => state.setBlockedState);

  useEffect(() => {
    (async () => {
      const location = await apiMain.getGeolocation();

      setCountry(location.country);
      setBlockedState(location.blockedState);
    })();
  }, []);
};
